import { combineReducers } from '@reduxjs/toolkit';

import usersReducer from './users';
//import doctorsReducer from './doctors';
//import patientsReducer from './patients';
//import clinicsReducer from './clinics';
import appointmentsReducer from './appointments';
import countReducer from './count.js';
import companiesReducer from './companies.js';

export default combineReducers({
  users: usersReducer,
  companies: companiesReducer,
  ///doctors: doctorsReducer,
  //patients: patientsReducer,
  //clinics: clinicsReducer,
  appointments: appointmentsReducer,
  count: countReducer,
});